import Feature from 'ol/Feature';
import Collection from 'ol/Collection';
import { Style, Stroke, Fill, Text } from 'ol/style';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { GeoJSON, WKT } from 'ol/format';
import { getContext } from '@/assets/js/mapContext';

export default {
  methods: {
    addUldkParcelLayer() {
      const feature = new Feature({});
      const features = new Collection();
      features.push(feature);
      const uldkParcelLayer = new VectorLayer({
        id: 'uldkParcelLayer',
        source: new VectorSource({
          features,
        }),
        zIndex: 10000,
        visible: true,
        style: feature => {
          const parcelTerrit = feature.get('parcelTerrit');
          return new Style({
            stroke: new Stroke({
              color: 'rgba(191, 54, 12, 1)',
              width: 2,
            }),
            fill: new Fill({
              color: 'transparent',
            }),
            ...(parcelTerrit
              ? {
                  text: new Text({
                    text: parcelTerrit,
                    font: 'normal 14px sans-serif',
                    fill: new Fill({ color: 'rgba(191, 54, 12, 1)' }),
                    stroke: new Stroke({
                      color: '#FFFFFF',
                      opacity: 1,
                      width: 3,
                      dash: [],
                    }),
                    overflow: true,
                  }),
                }
              : {}),
          });
        },
      });
      this.map.addLayer(uldkParcelLayer);
      uldkParcelLayer.feature = feature;
    },
    addUldkParcelToMap(geometry, parcelTerrit, { properties = {}, geometryType = 'wkt', multiFeatures = false } = {}) {
      const layer = this.getLayerById('uldkParcelLayer');
      if (layer && parcelTerrit) {
        const featureWithParcelTerrit = layer
          .getSource()
          .getFeatures()
          .find(f => f.get('parcelTerrit') === parcelTerrit);
        if (featureWithParcelTerrit) {
          getContext(this).$emit('fitView', featureWithParcelTerrit.getGeometry());
          return;
        }
      } else this.addUldkParcelLayer();
      let feature;
      if (geometryType === 'wkt') {
        let wktText = geometry;
        if (wktText.indexOf(';') >= 0) wktText = wktText.split(';')[1];
        feature = new WKT().readFeature(wktText, {
          dataProjection: this.$_config.defaultEpsg,
          featureProjection: this.$_config.defaultEpsg,
        });
      } else if (geometryType === 'geojson')
        feature = new GeoJSON().readFeature(geometry, {
          dataProjection: this.$_config.defaultEpsg,
          featureProjection: this.$_config.defaultEpsg,
        });
      if (feature) {
        const layer = this.getLayerById('uldkParcelLayer');
        if (layer) {
          feature.setProperties({
            ...properties,
            parcelTerrit,
            uldkParcel: !!properties.id_dzialki,
          });
          if (!multiFeatures) this.clearUldkParcel();
          layer.getSource().addFeature(feature);
        }
        getContext(this).$emit('fitView', feature.getGeometry());
      }
    },
    clearUldkParcel() {
      const layer = this.getLayerById('uldkParcelLayer');
      if (layer) layer.getSource().clear();
    },
  },
  mounted() {
    getContext(this).$off('addUldkParcelToMap');
    getContext(this).$off('clearUldkParcel');
    getContext(this).$on('addUldkParcelToMap', this.addUldkParcelToMap);
    getContext(this).$on('clearUldkParcel', this.clearUldkParcel);
  },
};
